export const styles = {
  boxStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { lg: "620px", md: "580px", sm: "85%", xs: "95%" },
    maxWidth: "640px",
    bgcolor: "#ffffff",
    borderRadius: "20px",
    boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.25)",
    maxHeight: "92vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    outline: "none",
  },
};
